import { IonCol } from '@ionic/react';
import React from 'react';

export interface Item {
    id: number,
    name: string,
    img: string,
    link: string,
    classImg: string
}

const ItemAbout: React.FC<Item> = props => {
  return (
    <IonCol className="ion-text-center" size="auto">
      {
        props.img !== '' ? (
          <div>
            <a href={props.link} target="_new">
              <img className={props.classImg} src={props.img} alt="item" />
            </a>
            <p>{props.name}</p>
          </div>
        )
          :
          (<p>{props.name}</p>)

      }
    </IonCol>
  )
}


export default ItemAbout;
